import React from "react"
import {makeStyles} from "@mui/styles"
import ActionHeader from "./ActionHeader"
import Button from "@mui/material/Button"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import {COLORS} from "../../utils"
import InputFlawProduct from "./InputFlawProduct"
import InputFlawDLC from "./InputFlawDLC"
import InputFlawNumberAndReason from "./InputFlawNumberAndReason"

const baseAction = {
	textAlign: "center",
	alignSelf: "center",
	width: "100%",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
}

const useStyles = makeStyles(() => ({
	root: {
		...baseAction,
		"& form": {
			...baseAction
		}
	},
	// Top-left of the page: the header is hidden while a flaw is declared, so the button takes
	// the place the design gives it instead of starting 164px down, where the header used to end.
	// The height matters as much as the offset. The first two steps start their question at 81px,
	// and at 59 the button reached 83, so on a narrow window it slid back under the text — the
	// very overlap this screen was reported for. The third step starts higher, at 57px, and is
	// clear of the button by its width rather than its height: its text is far enough right that
	// the two never meet. The width stays as it was, the design's 230 wrapping the label onto two
	// lines at this font size.
	buttonBack : {
		position: "absolute",
		width: 259,
		height: 47,
		left: 12,
		top: 24,
		background: COLORS.WHITE,
		border: `1px solid ${COLORS.GREY_BACK_BUTTON}`,
		borderRadius: 5,
		textTransform: "none",
		color: COLORS.GREY_SEARCH,
		fontSize: 19
	}
}))

const ActionFlawContent = (props) => {
	const {
		stepFlaw,
		handleClose,
		handleValidate,
		isTablet,
		setValue,
		flawProduct,
		flawDlc,
		lostActionInfos,
		// Everything the third step needs travels here rather than being named twice: naming it
		// is what silently dropped the fridge picker the first time round.
		...rest
	} = props
	const classes = useStyles()

	return (
		<>
			{/* header */}
			{ isTablet &&
				<ActionHeader text={""} handleClose={handleClose} noBorder={true} />
			}

			<div className={classes.root}>
				{
					!isTablet &&
						<Button
							className={classes.buttonBack}
							variant="outlined"
							startIcon={<ArrowBackIcon />}
							onClick={handleClose}
						>
							Annuler la déclaration
						</Button>
				}
				
				{/* select product display */}
				{ stepFlaw === 1  &&
					<InputFlawProduct
						handleValidate={handleValidate}
						isTablet={isTablet}
						setValue={setValue}
					/>
				}

				{/* select DLC display */}
				{ stepFlaw === 2  &&
					<InputFlawDLC
						handleValidate={handleValidate}
						isTablet={isTablet}
						setValue={setValue}
						flawProduct={flawProduct}
						flawDlc={flawDlc}
					/>
				}

				{/* select volume and reason display */}
				{ stepFlaw === 3  &&
					<InputFlawNumberAndReason
						handleValidate={handleValidate}
						isTablet={isTablet}
						setValue={setValue}
						flawProduct={flawProduct}
						lostActionInfos={lostActionInfos}
						{...rest}
					/>
				}
			</div>
		</>
	)
}

export default ActionFlawContent